export default "__VITE_ASSET__DQdkbEQk__";